import React from 'react';
import { motion } from 'framer-motion';
import { CheckIcon } from 'lucide-react';
import { Button } from '../ui/Button';
import { useBrand } from '../../contexts/BrandContext';
import { heroBenefits, trustMarks } from '../../data/site';
export function Hero() {
  const {
    brand
  } = useBrand();
  return <section className="bg-cream" data-id="element-68" data-mp="eqx1te8tb0ro">
      <div className="mx-auto max-w-shell px-6 pb-10 pt-12 md:px-8 md:pb-14 md:pt-20" data-id="element-69" data-mp="eplvp7rw9gxe">
        <div className="grid items-center gap-10 lg:grid-cols-[1.02fr_0.98fr] lg:gap-16" data-id="element-70" data-mp="apbh56q1di6x">
          <motion.div initial={{
          opacity: 0,
          y: 14
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.45,
          ease: [0.23, 1, 0.32, 1]
        }} data-id="element-71" data-mp="5ofib7kjkm8d">
            <h1 className="max-w-xl font-serif text-[2.75rem] font-bold leading-[1.02] tracking-tight text-ink sm:text-6xl lg:text-[4.25rem]" data-id="element-72" data-mp="3rxqg10k36yca">
              {brand.copy.heroTitle[0]}
              <br data-id="element-73" data-mp="1q4sjour3pnml" />
              {brand.copy.heroTitle[1]}
            </h1>
            <p className="mt-6 max-w-lg text-lg leading-relaxed text-ink-soft" data-id="element-74" data-mp="1mwccweoyjp1u">
              {brand.copy.heroSubhead} GLP-1s from <span className="text-ink" data-id="element-75" data-mp="1rvyoykt1uz92">$249/mo</span>, the
              same price at every dose.
            </p>

            <ul className="mt-8 flex flex-col gap-3" data-id="element-76" data-mp="1cz7yx259mzw4">
              {heroBenefits.map(benefit => <li key={benefit} className="flex items-center gap-3" data-id="element-77" data-mp="1hyar3m05dbmo">
                  <span className="inline-flex h-5 w-5 shrink-0 items-center justify-center rounded-full bg-brick text-cream" data-id="element-78" data-mp="25n3prq85lxkz">
                    <CheckIcon className="h-3 w-3" strokeWidth={3} data-id="element-79" data-mp="2akvk0qw9tvsc" />
                  </span>
                  <span className="text-base text-ink" data-id="element-80" data-mp="1vvzep1llmwvf">{benefit}</span>
                </li>)}
            </ul>

            <div className="mt-8 flex flex-wrap items-center gap-3" data-id="element-81" data-mp="20uj2l7jr6iqf">
              <Button to="/shop" size="lg" data-id="element-82" data-mp="2olg0hgeprfio">
                Explore care
              </Button>
              <Button to="/how-it-works" variant="secondary" size="lg" data-id="element-83" data-mp="2tcobggvoz8xy">
                How it works
              </Button>
            </div>
            <p className="mt-4 text-sm text-ink-muted" data-id="element-84" data-mp="337lrst94aio8">
              Takes about two minutes. You will not be charged to find out.
            </p>
          </motion.div>

          <motion.img initial={{
          opacity: 0,
          scale: 0.98
        }} animate={{
          opacity: 1,
          scale: 1
        }} transition={{
          duration: 0.5,
          delay: 0.06,
          ease: [0.23, 1, 0.32, 1]
        }} src={brand.images.hero} alt="A Republic member at home" className="aspect-[4/5] w-full rounded-brand object-cover lg:aspect-[4/4.4]" data-id="element-85" data-mp="2u6nko23dtv1f" />
        </div>
      </div>

      <div className="border-y border-ink/10 bg-cream-light" data-id="element-86" data-mp="2akiz4hr4h25w">
        <ul className="mx-auto flex max-w-shell flex-wrap justify-between gap-x-8 gap-y-3 px-6 py-5 md:px-8" data-id="element-87" data-mp="26inylfh0mst6">
          {trustMarks.map(mark => <li key={mark} className="flex items-center gap-2" data-id="element-88" data-mp="21i9ntpo154rg">
              <CheckIcon className="h-4 w-4 shrink-0 text-brick" strokeWidth={2.5} data-id="element-89" data-mp="1wjoqby05wz6p" />
              <span className="whitespace-nowrap text-[0.6875rem] uppercase tracking-label text-ink" data-id="element-90" data-mp="c2fi89vonvmq">
                {mark}
              </span>
            </li>)}
        </ul>
      </div>
    </section>;
}